import 'src/subcategories/shortcut_to_design';
import 'src/subcategories/value_adds';
import 'src/shared/tooltip';
import 'src/product_catalog';
import 'src/shared/gtm/listing';
import React from 'react';
import {PromoBanner} from '../components/DrinkwarePromo';
import {createRoot} from 'react-dom/client';
import isBeforePromoExpiry from '../utils/promoExpire';

const ecommerce = {
  item_list_id: parseInt($('meta[property=categoryinfo]').prop('id')),
  item_list_name: $('meta[property=categoryinfo]').attr('category_tree'),
  page_type: 'category'
};

const isDrinkwarePromoEnabled =
  isBeforePromoExpiry() &&
  StyleBitz.ScFeatureFlag.featureFlag('drinkware_promo_ad_v2') === 'on';

if (isDrinkwarePromoEnabled) {
  const promoDiv = document.getElementById('shared-promo');

  if (promoDiv) {
    const navRoot = createRoot(promoDiv);
    navRoot.render(
      <PromoBanner
        page={'subcat'}
        analyticsAttributes={{
          id: 5,
          creative_name: 'Drinkware'
        }}
      />
    );
  }
}
const augustTshirtsPromoDiv = document.getElementById('august-tshirts-promo');

if (augustTshirtsPromoDiv) {
  window.dataLayer.push({
    event: 'view_promotion',
    ecommerce: {
      creative_name: 'T-shirts',
      creative_slot: 'Category Page Banner',
      promotion_id: 460,
      promotion_name: 'August 2025 Tshirt Promo'
    }
  });
}

jQuery(() => ProductCatalog.gtmEcomEvent('products_subcategories', ecommerce));
